<div class="conteudo jornada">
    <img class="load" src="assets/img/loading.gif" alt="loading" style='display: none'>

    <app-dual-info-component 
      tituloPrincipal="Tempo total" 
      [infoPrincipal]="tempoTotalRoteiro"
      tituloSecundario="Tempo em visita" 
      [infoSecundario]="tempoTotalVisita" 
    >
    </app-dual-info-component>
 
    <table *ngIf="diasRoteiro.length>0" class="jornada-detalhes mb-2">
        <thead>
          <tr>
            <th>Dia do Roteiro</th>
            <th>Data</th>
            <th>Tempo diário</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of diasRoteiro; let i = index">
            <td>{{ (i + 1) | number: '2.0' }}</td>
            <td>{{ item.DT.replace('Z', '') | date: 'dd/MM/yyyy' }}</td>
            <td>{{ item.HoraCalcAcumuladaT }}:00</td>
          </tr>
        </tbody>
      </table>
</div>